// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"241":"62f857499ab9687f0b2d","488":"ccd5d14ff1a4cb7ebcb0","532":"8bbf4a81c065a9b9699d","592":"303afdabecfdcff5f860","736":"cda70a0de3086969bccc"}[chunkId] + ".js";
};